import React from 'react';

function Login(props) {
    return (
        <div>
            login

        </div>
    );
}

export default Login;